import { useState } from "react";
import { inputCls, labelCls, FormActions } from "./common";

const vide = { titre: "", date: "", lieu: "", description: "" };

export const ActiviteForm = ({ initial, onSave, onCancel, saving }) => {
  const [f, setF] = useState(initial || vide);
  const set = (champ) => (e) => setF({ ...f, [champ]: e.target.value });

  const soumettre = (e) => {
    e.preventDefault();
    onSave(f);
  };

  return (
    <form onSubmit={soumettre} className="space-y-5" data-testid="activite-form">
      <div>
        <label htmlFor="vf-titre" className={labelCls}>Titre *</label>
        <input id="vf-titre" required minLength={3} value={f.titre} onChange={set("titre")} className={inputCls} data-testid="activite-form-titre" />
      </div>
      <div className="grid gap-5 md:grid-cols-2">
        <div>
          <label htmlFor="vf-date" className={labelCls}>Date *</label>
          <input id="vf-date" required value={f.date} onChange={set("date")} className={inputCls} placeholder="Mai 2026" data-testid="activite-form-date" />
        </div>
        <div>
          <label htmlFor="vf-lieu" className={labelCls}>Lieu *</label>
          <input id="vf-lieu" required value={f.lieu} onChange={set("lieu")} className={inputCls} placeholder="En ligne / Montréal" data-testid="activite-form-lieu" />
        </div>
      </div>
      <div>
        <label htmlFor="vf-description" className={labelCls}>Description *</label>
        <textarea id="vf-description" required minLength={10} rows={4} value={f.description} onChange={set("description")} className={`${inputCls} resize-y`} data-testid="activite-form-description" />
      </div>
      <FormActions saving={saving} onCancel={onCancel} />
    </form>
  );
};
